// Where Next at the end of a level takes the player (MUS-570).
//
// The next level starts the way roadmap Play would start it: in its lesson
// when its tutorial is done (or a tier there is complete), in its tutorial
// otherwise. The decision is the roadmap's own (`resolveLevelPlayRoute`), and
// the lesson opens on the tier Play would open (`resolveEntryTier`), so the
// two ways into a level cannot disagree.
import { LevelData, UserLevelData } from 'Types';
import { resolveEntryTier } from 'Utils/EntryTier';
import { CompletedTutorials, resolveLevelPlayRoute } from 'Utils/tutorialCompletion';

export type NextLevelStart =
  | {
      route: '/lesson';
      /** The next level's INDEX into `levelData`. */
      levelSelect: number;
      levelNumber: number;
      tierNumber: number;
    }
  | { route: '/tutorial' };

export type NextLevelStartInputs = {
  levelData: LevelData[] | undefined;
  /** The finished level's INDEX into `levelData`. */
  levelSelect: number;
  userLevelData: UserLevelData[] | undefined;
  completedTutorials: CompletedTutorials;
  /** The tier this app session remembers for a level, or null. See `Utils/TierMemory`. */
  recallTier: (levelNumber: number) => number | null;
};

export const nextLevelStart = ({
  levelData,
  levelSelect,
  userLevelData,
  completedTutorials,
  recallTier,
}: NextLevelStartInputs): NextLevelStart => {
  const nextLevelSelect = levelSelect + 1;
  const route = resolveLevelPlayRoute({
    levelData,
    levelSelect: nextLevelSelect,
    userLevelData,
    completedTutorials,
  });
  const levelNumber = levelData?.[nextLevelSelect]?.level_number;
  if (route !== '/lesson' || levelNumber === undefined) return { route: '/tutorial' };
  const { tierNumber } = resolveEntryTier({
    levelData,
    levelSelect: nextLevelSelect,
    userLevelData,
    rememberedTier: recallTier(levelNumber),
  });
  return { route: '/lesson', levelSelect: nextLevelSelect, levelNumber, tierNumber };
};
